<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     页面顶部Header组件
  +---------------------------------------------------------------------------------------
-->
<template>
	<div class="f-page-header flex justify-content-space-between" :class="{
      'is-collapse': $route.meta.layout || (!$route.meta.layout && isCollapse),
    }">
		<div class="flex align-items-center">
			<el-tooltip :content="isCollapse ? '展开菜单' : '隐藏菜单'" placement="bottom">
				<div class="flex-center font-2x text-lighter fold-btn text-muted" @click="toggleMenu()">
					<i v-if="isCollapse" class="el-icon-s-unfold" />
					<i v-else class="el-icon-s-fold" />
				</div>
			</el-tooltip>
			<div class="title ml font-lg">
				{{ $route.meta.abbr ? $route.meta.abbr + " / " : ""
        }}{{ $route.meta.title }}
			</div>
		</div>

		<div class="flex align-items-center" role="button">
			<span v-if="messages" @click="toMsg()">
				<el-badge :value="messages" class="badge number">
					<i class="el-icon-bell font-2x" style="margin-top: 4px"></i>
				</el-badge>
			</span>
			<i v-else class="el-icon-bell font-2x" style="margin-right: 5px" @click="toMsg()"></i>

			<el-popover placement="bottom-end" width="280" :offset="0" :visible-arrow="false" trigger="hover">
				<div class="pop_content" role="button">
					<div class="flex align-items-center" @click="toMe()">
						<div class="hd">
							<f-user-avatar :user="user" shape="circle" :fill="true" :preview="false"></f-user-avatar>
						</div>
						<div class="bd ml mr">
							<div v-if="user && user.username" class="font-md text-black">
								{{ user.username }}
							</div>
							<div class="text-muted mt-xs">
								{{ $store.state.godStore.short_name }}
							</div>
						</div>
						<div class="ft flex-center">
							<div class="text-muted">{{ "个人中心" }}</div>
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
					<el-divider></el-divider>
					<div class="flex-center text-black" @click="logout()">
						<i class="iconfont icon-logout" role="button"></i>
						<div class="mt-xs mb-xs ml-xs">{{ "退出登录" }}</div>
					</div>
				</div>
				<div slot="reference" class="flex">
					<!-- <div class="ml-lg mr-sm">{{ user.username }}</div> -->
					<f-user-avatar :user="user" size="mini" shape="circle" :fill="true" :preview="false" class="ml-lg"></f-user-avatar>
				</div>
			</el-popover>
		</div>
	</div>
</template>

<script>
export default {
	name: "FPageHeader",

	data () {
		return {
			secondTimerId: null,
			counter: 1,
			pollingCt: 60,
		};
	},

	computed: {
		isCollapse () {
			return this.$store.state.commonStore.collapse;
		},
		messages () {
			return this.$store.state.commonStore.messageNum;
		},
		user () {
			return this.$store.state.userStore.user;
		},
	},
	created () {
		this.secondTimerId = setInterval(() => {
			this.counter += 1;
			if (this.counter >= this.pollingCt) {
				this.counter = 0;
				this.fetchMessageNum();
			}
		}, 1000);
		this.fetchMessageNum();
	},

	beforeDestroy () {
		if (this.secondTimerId) {
			clearInterval(this.secondTimerId);
		}
	},

	methods: {
		toggleMenu () {
			this.$store.commit("SET_COLLAPSE", this.isCollapse ? false : true);
		},

		logout () {
			this.$store.dispatch("fedLogOut").then(() => {
				location.reload();
			});
		},

		toMe () {
			this.$router.push("/me/me");
		},

		toMsg () {
			this.$msg();
		},
		fetchMessageNum () {
			this.$store.dispatch("getUnreadMessageNum").then((res) => {
				// console.log(res, '消息获取')
			});
		},
	},
};
</script>

<style lang="scss" slot-scoped>
.f-page-header {
	position: fixed;
	top: 0;
	bottom: 60px;
	left: 160px;
	right: 0;
	background-color: #fff;
	border-top-left-radius: 20px;
	padding: 16px 30px;
	height: 60px;
	line-height: 28px;
	z-index: 101;
	transition: all 0.2s;
	&.is-collapse {
		left: 60px;
		border-top-left-radius: 0px;
	}
}
.el-badge__content.is-fixed {
	top: 8px;
	right: 12px;
}
.el-divider--horizontal {
	margin: 12px 0;
}
.icon-logout {
	font-size: 18px;
}
.fold-btn {
	cursor: pointer;
}
</style>
